module.exports = __webpack_public_path__ + "static/img/demo_profile2.64deffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/demo_profile2.png
// module id = Xr3C
// module chunks = 150